export default __webpack_public_path__ + "static/media/buy_gmx_bond.43cecd0b.svg";